import {
  Button,
  Colors,
  Modal,
  Typography
} from '@giantleap/components-library'
import * as React from 'react'
import styles from './style.module.scss'
import { IProps } from './types'

function ReavaluateModal({
  onButtonClick,
  active,
  setActive,
  childName
}: IProps) {
  return (
    <Modal active={active} setActive={setActive} baseClassName={styles.wrap}>
      <Typography type="title" size="big" textAlign="center">
        It’s time<i style={{ color: Colors.redAccent }}>!</i>
      </Typography>
      <Typography type="text" textAlign="center">
        {childName} can now <b>re-take the GiantLeap evaluation</b>
      </Typography>
      <Typography type="text" textAlign="center">
        <b>Past results will remain available</b> to you, so you can track
        progress over time
      </Typography>
      <Button color="pink" onClick={onButtonClick}>
        Start New Evaluation
      </Button>
    </Modal>
  )
}

export default ReavaluateModal



// WEBPACK FOOTER //
// ./src/components/ReavaluateModal/index.tsx